import { Notify } from 'vant'

function legacyCopy(text) {
  if (!document || !document.body) {
    return false
  }

  const textarea = document.createElement('textarea')
  textarea.value = text
  textarea.setAttribute('readonly', 'readonly')
  textarea.style.position = 'fixed'
  textarea.style.top = '0'
  textarea.style.left = '-9999px'
  textarea.style.opacity = '0'
  textarea.style.pointerEvents = 'none'
  textarea.style.fontSize = '16px'

  document.body.appendChild(textarea)

  try {
    textarea.focus()
    textarea.select()
    textarea.setSelectionRange(0, textarea.value.length)
    return document.execCommand('copy')
  } finally {
    document.body.removeChild(textarea)
  }
}

export async function copyContent(text, message = '\u590d\u5236\u6210\u529f') {
  try {
    if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
      try {
        await navigator.clipboard.writeText(text)
      } catch (clipboardError) {
        if (!legacyCopy(text)) {
          throw clipboardError
        }
      }
    } else if (!legacyCopy(text)) {
      throw new Error('Clipboard API unavailable')
    }

    Notify({ type: 'success', message, duration: 1200 })
  } catch (error) {
    Notify({ type: 'danger', message: '\u590d\u5236\u5931\u8d25', duration: 1200 })
    throw error
  }
}
